/**
 * @Description: INFO_DETAIL
 * @author XuZiYu
 * @date 2021/07/17 15:58:39
*/
<template>
  <div class="wrapper">
    <ctl-header :title="'查看个人信息'"></ctl-header>

    <van-cell-group class="main">
      <van-field
        readonly
        input-align="right"
        v-model="form.subjectName"
        label="考试科目"
      >
      </van-field>
      <van-field
        size="large"
        input-align="right"
        v-model="form.examCityCode"
        readonly
        label="学车省市"
      />
      <van-field
        readonly
        input-align="right"
        v-model="form.stuName"
        label="学员姓名"
      >
      </van-field>
      <van-field
        readonly
        input-align="right"
        label="证件号"
      >
        <div slot="input">
          {{form.stuIdcard | coding([3,14,1])}}
        </div>
      </van-field>
    </van-cell-group>
    <div class="rule">一个身份证信息单科目仅能补偿一次，以上信息将用于申请补偿时核实考生信息，若信息有误将会影响补偿结果。</div>
  </div>
</template>

<script>
import { Area, Popup, Field, CellGroup, Button, Toast } from 'vant'
import { areaList } from '@vant/area-data'

export default {
    name: 'infoDetail',
    components: {
        [Area.name]: Area,
        [Button.name]: Button,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Popup.name]: Popup,
        [Toast.name]: Toast
    },
    data () {
        return {
            areaShow: false,
            loading: false,
            isSubmit: false,
            areaList: areaList,
            form: {
                subjectName: '',
                stuIdcard: '',
                stuName: '',
                examCityCode: '',
                examCityName: ''
            }
        }
    },
    watch: {},
    filters: {
        coding (v, rule) {
            if (!v) {
                return
            }
            let firstString = v.substring(0, rule[0])
            let secondString = ''
            let threeString = v.substring(v.length - rule[2], v.length)
            for (let n = 0; n < rule[1]; n++) {
                secondString += '*'
            }
            return `${firstString}${secondString}${threeString}`
        }
    },
    methods: {
        getInfo () {
            let version = this.$jsBridge.callBackHandler('getAppVersion')

            this.$api.getVipMatchEntry({ version: version }).then(res => {
                if (res.status) {
                    this.form = res.result.examIsVipPageDataDTO ? res.result.examIsVipPageDataDTO : {}
                    this.form.subjectName = '科目一、科目四'
                } else {
                    Toast.fail(res.message)
                }
            })
        }
    },
    created () {
        this.getInfo()
    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
  *{
    font-family: PingFang SC;
  }

  /deep/ {
    .van-cell-group::after{
      border-width:0;
    }

    .van-cell{
      padding: 20px 15px;
    }

    .van-field__label{
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }
    .van-field__control::placeholder{
      font-size: 15px;
      font-weight: 400;
      color: #999999;
    }
    .van-field__control{
      font-size: 15px;
      font-weight: 400;
      color: #53CB85;
    }
    .icon-clear{
      width: 18px;
      height: 18px;
    }
    .van-field__body{
      display: flex;
      align-items: center;
    }
    .van-field__right-icon{
      display: flex;
      align-items: center;
    }
    .van-cell:last-child::after{
      display: block;
    }
  }

  .rule {
    padding: 10px 15px 0;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }
</style>
